@import "../../../common/_base";

:host {
  display: block;
}
:where(button) {
  all: unset;
  display: flex;
  width: 100%;
  cursor: pointer;
}

@include box-sizing();
